import { TRootState } from '@/redux/rootReducer';

export const selectNearbyCampgrounds = (state: TRootState) => state.nearbyCampgrounds.data;
export const selectNearbyCampgroundsLoaded = (state: TRootState) =>
  state.nearbyCampgrounds.isFetched;
